import React, { useState, useEffect, useRef } from "react";
// import Select from "react-select";

import "./ItemChips.css";
import { getCustomToken } from "../helpers/utils";

function ItemChips(props) {
  const [error, setError] = useState(null);
  const [suggestions, setSuggestions] = useState([]);
  // const [items, setItems] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false); // State to control suggestion visibility

  useEffect(() => {
    // Perform any side effects or computations based on the updated 'users' data
    console.log("Users updated:", props.items);
  }, [props.items]); // Dependency array with 'users'

  const [searchText, setSearchText] = useState("");
  const [debouncedValue, setDebouncedValue] = useState("");

  useEffect(() => {
    fetchSuggestions(debouncedValue); // Fetch initial suggestions on component mount
  }, [debouncedValue]);

  const handleChange = (event) => {
    setSearchText(event.target.value);
    setError(null);

    if (event.target.value.length > 1) {
      setShowSuggestions(true);
    }
  };

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setDebouncedValue(searchText);
    }, 500);
    return () => clearTimeout(timeoutId);
  }, [searchText]);

  const fetchSuggestions = async (search) => {
    try {
      let apiUrl = `${process.env.REACT_APP_BACKEND_URL}/users?page=1&size=10&dropdown=true`;

      // Check if 'search' is not empty
      if (search !== "") {
        apiUrl += `&search=${search}`;
      }

      const response = await fetch(apiUrl, {
        headers: {
          Authorization: `Bearer ${getCustomToken()}`,
        },
      }); // Replace with your actual API endpoint
      const data = await response.json();
      setSuggestions(data.items || []); // Assuming the API response has a "suggestions" property
    } catch (error) {
      console.error("Error fetching suggestions:", error);
    }
  };

  const handleDelete = (item) => {
    props.setItems(props.items.filter((i) => i !== item));
  };

  // const handlePaste = (evt) => {
  //   evt.preventDefault();
  //   const paste = evt.clipboardData.getData("text");
  //   const emails = paste.match(/[\w\d\\.-]+@[\w\d\\.-]+\.[\w\d\\.-]+/g);

  //   if (emails) {
  //     const toBeAdded = emails.filter((email) => !isInList(email));
  //     setItems([...items, ...toBeAdded]);
  //   }
  // };

  const selectSuggestion = (suggestion) => {
    // setItems([...items, suggestion]); // Add suggestion directly to items state

    // Check for existing item with the same ID
    const existingIndex = props.items.findIndex(
      (item) => item.users.id === suggestion?.id
    );

    if (existingIndex === -1) {
      // Add new item if not found

      props.setItems([
        ...props.items,
        {
          users: {
            display_name: suggestion.display_name,
            email_id: suggestion.email_id,
            id: suggestion.id,
          },
        },
      ]);
    }

    inputRef.current.focus(); // Set focus to the input field

    setSuggestions([]); // Clear suggestions after selection
    setSearchText("");
    setShowSuggestions(false);
  };

  // const isValid = (email) => {
  //   let error = null;

  //   if (isInList(email)) {
  //     error = `${email} has already been added.`;
  //   } else if (!isEmail(email)) {
  //     error = `${email} is not a valid email address.`;
  //   }

  //   if (error) {
  //     setError(error);
  //     return false;
  //   }

  //   return true;
  // };

  // const isInList = (email) => items.includes(email);

  // const isEmail = (email) => /[\w\d\\.-]+@[\w\d\\.-]+\.[\w\d\\.-]+/.test(email);

  const renderSuggestions = () => {
    return suggestions.map((suggestion) => (
      <div
        className="suggestion"
        key={suggestion.id}
        onClick={() => {
          console.log("CLICKED: ", suggestion);
          selectSuggestion(suggestion);
        }}
      >
        {suggestion.display_name}
      </div>
    ));
  };

  // const handleFocus = () => {
  //   setShowSuggestions(true); // Show suggestions on input focus
  //   fetchSuggestions(debouncedValue); // Fetch initial suggestions on component mount
  // };

  // const handleBlur = () => {
  //   setShowSuggestions(false); // Show suggestions on input focus
  // };

  const inputRef = useRef(null); // Ref to reference the input field

  return (
    <div className="row">
      <div className="col-md-12">
        {props.items.map((item) => {
          console.log("ITEM: ", item);
          return (
            <div className="tag-item" key={item.users.id}>
              {item.users.display_name}
              <button
                type="button"
                className="button"
                onClick={() => handleDelete(item)}
              >
                &times;
              </button>
            </div>
          );
        })}
      </div>

      <div className="col-md-12">
        <div className="form-group form-border">
          <label>
            {props.label}:
            {props.is_required && <span style={{ color: "red" }}> * </span>}
            <span style={{ color: "red" }}>{error}</span>
          </label>

          <input
            ref={inputRef}
            className={"form-control  " + (error && " has-error")}
            value={searchText}
            placeholder="Type or paste email addresses and press `Enter`..."
            // onKeyDown={handleKeyDown}
            onChange={handleChange}
            // onPaste={handlePaste}
            // onFocus={handleFocus}
            // onBlur={handleBlur}
          />
        </div>

        {showSuggestions && (
          <div className="suggestions">{renderSuggestions()}</div>
        )}
      </div>
    </div>
  );
}

export default ItemChips;
